
import React, { useState, useReducer } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Container, Row } from 'react-bootstrap';

import "../style/App.css";


const formReducer = (state, event) => {
    if (event.reset) {
        return {
            name: '',
            email: '',
            query: '',
        }
    }
    return {
        ...state,
        [event.name]: event.value
    }
}

const Contact = () => {


    const [formData, setFormData] = useReducer(formReducer, {  });
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);


    const handleSubmit = event => {
        event.preventDefault();
        setSuccess(false);
        setSubmitting(true);

        console.log('submiting contact query:');
        fetch('/api/submitContactForm', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(res => res.json()).then(data => {
                console.log('Query submitted', data.message);
                setSubmitting(false);
                setFormData({ reset: true });
                if ( data.status === 'SUCCESS' ) {
                    setSuccess(true);
                }
                
            })
            .catch(error => console.log(error))
    }


    const handleChange = event => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        })
    }


    return (
        <Container className="med-width-container" >
        <Row className="px-1 mx-4">
            <h1>LETS WORK TOGETHER</h1>
        </Row>
        <Row className='px-3 mx-3'>
            <p>Please provide your query to CFI Surgery. We will be happy to respond as soon as possible. </p>
            {success && <p><em>Thank you for your message. We will contact you shortly.</em></p>}
        </Row>
        <Row className='py-5 my-5'>
            <Form onSubmit={handleSubmit} disabled={submitting}>
                <Form.Group className="mb-3 mx-5" controlId="formBasicName">
                    {/* <Form.Label>Name</Form.Label> */}
                    <Form.Control type="textarea" name="name" onChange={handleChange} value={formData.name || ''} placeholder="Name"  />
                </Form.Group>

                <Form.Group className="mb-3 mx-5" controlId="formBasicEmail">
                    {/* <Form.Label>Email address</Form.Label> */}
                    <Form.Control type="email" name="email" onChange={handleChange} value={formData.email || ''}  placeholder="Email"/>
                </Form.Group>

                <Form.Group className="mb-3 mx-5" controlId="QueryText">
                    {/* <Form.Label>Query</Form.Label> */}
                    <Form.Control as="textarea" name='query' rows={3} onChange={handleChange} value={formData.query || ''} placeholder="Message"/>
                </Form.Group>

                <Button variant="danger" type="submit" disabled={submitting}>
                    Send message
                </Button>
            </Form>
        </Row>
        </Container>
    );
}

export default Contact;